import { Flex, Label } from "@braze/beacon-core"
import styled from "styled-components"
import { useAnalysisContext } from "../../../contexts/AnalysisContext";



export const TotalMetrics = (() => {

    const { analysisTotalMetrics } = useAnalysisContext();

    return (
        <Flex direction="column">
            <Metric title="Campaigns" value={analysisTotalMetrics.total_campaigns.toLocaleString()}/>
            <Metric title="Budget" value={analysisTotalMetrics.total_budget.toLocaleString()}/>
            <Metric title="NNLs" value={analysisTotalMetrics.total_nnls.toLocaleString()}/>
            <Metric title="MQLs" value={analysisTotalMetrics.total_mqls.toLocaleString()}/>
            <Metric title="SQLs" value={analysisTotalMetrics.total_sqls.toLocaleString()}/>
            <Metric title="Pipe Count" value={analysisTotalMetrics.total_pipe_count.toLocaleString()}/>
            <Metric title="Pipe Amount" value={Math.round(analysisTotalMetrics.total_pipe_amount).toLocaleString()}/>
        </Flex>
    )
})


const Metric = (({title, value} : {title : string, value : number|string}) => {

    return value === undefined ? (
        <>
        </>
    ) : (
        <Flex style={{width:"100%", justifyContent: "space-between"}}>
            <TitleLabel>{title}:</TitleLabel>
            <ValueLabel>{value}</ValueLabel>
        </Flex>
    )
})

const TitleLabel = styled(Label)`

    font-size: 18px;
    margin-right: 2rem;
`

const ValueLabel = styled(Label)`
    font-size: 16px;
    font-weight: normal;
`